export class Account {
    accountId: string = '';
    name: string = '';
    city: string = '';
    state: string = '';
    serialNumber: string = '';
    display: string = '';
    licenseCount: number = 0;
    migratedToOkta: boolean = false;
}